import { apiClientName, apiRegistro } from '@/plugins/axios'

export default {
  getClientName() {
    return apiClientName().get('/cliente')
  },

  async getCan(permission) {
    const response = await apiRegistro().get(`/can/${permission}`)

    return response.data.authorization
  },

  async getCanOperador(permission) {
    const response = await apiRegistro().get(`/can/${permission}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token_operador')}`,
      },
    })
    return response.data.authorization
  },

  async getRefresh() {
    let token = await apiRegistro().get('/refresh')
    return token
  },
}
